import type { ModuleRoute } from '../types';
import { ExportPage } from './ExportPage';
import { InvoicesPage } from './InvoicesPage';
import { OverviewPage } from './OverviewPage';
import { PlansPage } from './PlansPage';
import { SubscriptionPage } from './SubscriptionPage';
import { TenantBillingPage } from './TenantBillingPage';

/** Pages of this area (billing: platform plans, subscriptions, invoices, credit notes, payments, export; the tenant billing page). Owned by Phase 4 task W26; only that task edits files in this folder (W32 wires it last). */
export const routes: ModuleRoute[] = [
  { path: '/admin/billing', element: <TenantBillingPage />, permission: 'billing.view' },
  { path: '/platform/billing', element: <OverviewPage />, permission: 'platform.billing_view', area: 'platform' },
  { path: '/platform/billing/plans', element: <PlansPage />, permission: 'platform.billing_view', area: 'platform' },
  { path: '/platform/billing/invoices', element: <InvoicesPage />, permission: 'platform.billing_view', area: 'platform' },
  { path: '/platform/billing/export', element: <ExportPage />, permission: 'platform.billing_view', area: 'platform' },
  { path: '/platform/billing/tenants/:tenantId', element: <SubscriptionPage />, permission: 'platform.billing_view', area: 'platform' },
];
